import { Icon, HorizontalDivider, Button } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { useNotification, useShoppingCart } from '@hero/store/hooks';

import * as S from './style';

export const SearchList = React.forwardRef(({ onSearchByRecent, setIsSearchListOpen }, ref) => {
  const { t } = useTranslation();
  const { showNotification } = useNotification();

  const { searchList, removeSearch, resetSearchList } = useShoppingCart();

  const handleRemoveSearch = (e, searchList) => {
    e.stopPropagation();
    removeSearch(searchList);
  };

  const clearSearchListList = () => {
    setIsSearchListOpen(true);
    resetSearchList();
  };

  const onClearHistoryModal = () => {
    showNotification({
      title: t('clearSearchTitle'),
      message: t('clearSearchDescription'),
      primaryButtonProps: {
        children: t('clearHistory'),
        onClick: clearSearchListList
      },
      secondaryButtonProps: {
        children: t('cancel')
      },
      bodyStyle: {
        alignItems: 'flex-start'
      },
      messageStyle: {
        textAlign: 'left'
      }
    });
  };

  return (
    <S.SearchList ref={ref}>
      <S.SearchListInfo>
        <Trans i18nKey="searchBarInfo" components={{ b: <b /> }} />
      </S.SearchListInfo>
      {searchList?.length ? (
        <S.SearchListList>
          <S.SearchListListHeader>
            {t('recentSearch')}
            <Button variant="link" onClick={onClearHistoryModal}>
              {t('clear')}
            </Button>
          </S.SearchListListHeader>
          <HorizontalDivider />
          <S.SearchListListItems>
            {searchList.map(item => (
              <S.SearchListListItem onClick={() => onSearchByRecent(item)} key={item}>
                <S.SearchListListItemText>{item}</S.SearchListListItemText>
                <Icon
                  onClick={e => handleRemoveSearch(e, item)}
                  name="close"
                  color="var(--color-accent-secondary-default)"
                />
              </S.SearchListListItem>
            ))}
          </S.SearchListListItems>
        </S.SearchListList>
      ) : (
        <S.NoResentSearch>{t('noRecentSearches')}</S.NoResentSearch>
      )}
    </S.SearchList>
  );
});

SearchList.propTypes = {
  onSearchByRecent: PropTypes.func,
  setIsSearchListOpen: PropTypes.func
};

SearchList.displayName = 'SearchList';
